import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import authAxios from '../lib/authAxios';
import { useAuth } from '../contexts/AuthContext';

const MagicAuthPage = () => {
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const hasExchanged = useRef(false);
  const { login } = useAuth();

  useEffect(() => {
    if (hasExchanged.current) return;

    const exchangeToken = async () => {
      const searchParams = new URLSearchParams(location.search);
      const token = searchParams.get('token');
      const postId = searchParams.get('post');

      if (!token) {
        setError('No authentication token found.');
        return;
      }

      try {
        const response = await authAxios.post('/exchange-token', { token });
        const { accessToken, user, csrfToken } = response.data.data;

        // Secure: store token in-memory, user metadata in localStorage
        login(accessToken, user, csrfToken);

        // Redirect to post or dashboard/feed based on role
        if (postId) {
          navigate(`/posts/${postId}`);
        } else {
          navigate(user.role === 'student' ? '/dashboard' : '/feed');
        }
      } catch (err) {
        console.error('Token exchange failed:', err);
        setError('Authentication failed. The link may have expired.');
        setTimeout(() => navigate('/login'), 3000);
      }
    };

    hasExchanged.current = true;
    exchangeToken();
  }, [location, navigate, login]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="p-8 bg-white shadow-lg rounded-lg max-w-md w-full text-center">
        {error ? (
          <div className="text-red-600">
            <h2 className="text-xl font-bold mb-2">Error</h2>
            <p>{error}</p>
            <p className="mt-4 text-sm text-gray-500">Redirecting to login...</p>
          </div>
        ) : (
          <div>
            <h2 className="text-xl font-bold mb-4">Authenticating...</h2>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
            <p className="mt-4 text-gray-600">Please wait while we sign you in.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MagicAuthPage;
